import { Tag } from "antd";
import React from "react";
type Props = {
  gender: string;
};
const GenderTag = ({ gender }: Props) => {
  return (
    <>
      {gender === "MALE" ? (
        <Tag color="blue">Male</Tag>
      ) : (
        <Tag color="pink">Female</Tag>
      )}
    </>
  );
};

export default GenderTag;
